import { render } from "./ProfileBreadcrumbs.vue?vue&type=template&id=2db5490e"
import script from "./ProfileBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./ProfileBreadcrumbs.vue?vue&type=script&lang=js"

import "./ProfileBreadcrumbs.vue?vue&type=style&index=0&id=2db5490e&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__